import { Typography } from '@mui/material';
import { Modal, Spacer } from '../../components';

interface DeleteModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: (row: any) => void;
  activeData: any;
}

const LicenseDeleteModal: React.FC<DeleteModalProps> = ({ open, setOpen, onSave, activeData }) => {
  return (
    <Modal
      title={'Cancel contract?'}
      handleSave={() => onSave(activeData)}
      open={open}
      setOpen={setOpen}
      primaryButtonText={'Yes, cancel'}
      secondaryButtonText={'No, keep'}>
      <Typography variant='p14' color='secondary.main' gutterBottom>
        Are you sure you want to cancel this active contract?
      </Typography>
      <Spacer height='sm' />
      <Typography variant='p14' color='secondary.main' gutterBottom>
        This action cannot be undone.
      </Typography>
      <Spacer height='sm' />
    </Modal>
  );
};

export default LicenseDeleteModal;
